import React, { useState } from "react";
import { IForm } from "../../../../types/form.type";
import ModalForm from "../../modal/ModalForm";
import { useForm } from "react-hook-form";
import { Stack } from "@mui/material";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  asyncPostData,
  asyncPutData,
  uploadFile,
} from "../../../../utils/httpRequests";
import { useSelector } from "react-redux";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";
import InfoSection from "./info-section/InfoSection";
import ImageSection from "./image-section/ImageSection";
import DescriptionSection from "./description-section/DescriptionSection";

const schema = yup.object({
  ten_vt: yup.string().required("Vui lòng nhập tên hàng hóa"),
  don_vi_tinh: yup
    .object()
    .typeError("Vui lòng chọn đơn vị tính")
    .required("Vui lòng chọn đơn vị tính"),
});

function FormMonAn({
  defaultValues,
  isEdit,
  apiCode,
  open,
  onClose,
  setLoad,
}: IForm) {
  const app = useSelector((state: any) => state.app.data);
  const token = useSelector((state: any) => state.auth.token);
  const { showAlert } = useAlertContext();
  const [thumbnails, setThumbnails] = useState<{ [key: string]: File | null }>({
    picture: null,
    picture2: null,
    picture3: null,
  });
  const defaultData: { [key: string]: any } = {
    ma_vt: "",
    ten_vt: "",
    don_vi_tinh: null,
    nhom_vat_tu: null,
    gia_ban_le: "",
    gia_mua: "",
    tg_tk: false,
    mieu_ta: "",
    sp_yeu_cau_che_bien: true,
    sp_yeu_cau_pha_che: true,
  };
  const originData = defaultValues
    ? {
        ...defaultData,
        ...defaultValues,
        don_vi_tinh: defaultValues?.ma_dvt
          ? {
              ma_dvt: defaultValues.ma_dvt || "",
              ten_dvt: defaultValues.ten_dvt || "",
            }
          : null,
        nhom_vat_tu: defaultValues?.ma_nvt
          ? {
              _id: defaultValues.ma_nvt || "",
              ten_nvt: defaultValues.ten_nvt || "",
            }
          : null,
      }
    : defaultData;

  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting, errors },
  } = useForm({
    mode: "onSubmit",
    defaultValues: originData,
    resolver: yupResolver(schema),
  });

  const handleReset = () => {
    reset(originData);
    setThumbnails({
      picture: null,
      picture2: null,
      picture3: null,
    });
  };

  const generateDataPost = async (values: typeof defaultData) => {
    const { don_vi_tinh, nhom_vat_tu, ...fields } = values;

    const result: { [key: string]: any } = {
      ...fields,
      ma_dvt: don_vi_tinh?.ma_dvt || "",
      ten_dvt: don_vi_tinh?.ten_dvt || "",
      ma_nvt: nhom_vat_tu?._id || "",
      ten_nvt: nhom_vat_tu?.ten_nvt || "",
    };

    // save picture
    const entrieImages = Object.entries(thumbnails);
    for (let i = 0; i < entrieImages.length; i++) {
      const entry = entrieImages[i];
      if (!!entry[1]) {
        const formData = new FormData();
        formData.append("file", entry[1]);
        const respFile = await uploadFile({
          formData,
          folder: "products",
          token,
        });
        if (respFile.status === 200) {
          result[entry[0]] = respFile?.data?.fileUrl;
        }
      } else if (entry[1] === undefined) {
        result[entry[0]] = "";
      }
    }
    return result;
  };

  const handleSave = async (values: typeof defaultData) => {
    const dataPost: { [key: string]: any } = await generateDataPost(values);
    let resp = null;
    if (isEdit) {
      resp = await asyncPutData({
        id: dataPost._id,
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    } else {
      resp = await asyncPostData({
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    }
    if (resp.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.message || "Lỗi khi lưu đối tượng",
      });
    } else {
      onClose();
      setLoad?.((prev: number) => prev + 1);
    }
  };

  const onSubmit = handleSubmit(handleSave);

  return (
    <ModalForm
      formWidth="1000px"
      formTitle="món"
      loading={isSubmitting}
      open={open}
      isEdit={isEdit}
      onClose={onClose}
      onSubmit={onSubmit}
      onReset={handleReset}
    >
      <Stack gap={2}>
        <InfoSection
          isEdit={isEdit}
          control={control}
          register={register}
          errors={errors}
        />
        <ImageSection
          defaultValues={defaultValues}
          setThumbnails={setThumbnails}
        />
        <DescriptionSection control={control} />
      </Stack>
    </ModalForm>
  );
}

export default FormMonAn;
